import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { getEntityKeyFromPath, useTableStateStore } from 'src/store/table-state/table-state.store';

// ----------------------------------------------------------------------

/**
 * Monitora a URL e, ao detectar troca de entidade, limpa imediatamente o
 * estado (filtros + paginação) da entidade que o usuário acabou de sair.
 *
 * Deve ser montado UMA única vez no DashboardLayout, para que esteja sempre
 * ativo enquanto o usuário navega no painel.
 */
export function useEntityTracker(): void {
  const { pathname } = useLocation();
  const prevEntityKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const currentEntityKey = getEntityKeyFromPath(pathname);
    const prevEntityKey = prevEntityKeyRef.current;

    if (currentEntityKey !== null && prevEntityKey !== null && prevEntityKey !== currentEntityKey) {
      const store = useTableStateStore.getState();
      const prevResetFn = store.entityResetFunctions[prevEntityKey];
      if (prevResetFn) prevResetFn();
      store.clearEntityFilterState(prevEntityKey);
    }

    if (currentEntityKey !== null) {
      prevEntityKeyRef.current = currentEntityKey;
      useTableStateStore.getState().setLastActiveEntityKey(currentEntityKey);
    }
  }, [pathname]);
}
